import { type OutputKind, type RenderableOutput } from './outputTypes'

export const OUTPUT_KIND_LABELS: Record<OutputKind, string> = {
  html: 'Rich text',
  text: 'Text',
  number: 'Number',
  boolean: 'Boolean',
  empty: 'Empty',
  file: 'File',
  'file-list': 'Files',
  json: 'JSON',
  email: 'Email',
  markdown: 'Markdown',
  table: 'Table',
  keyValue: 'Details',
  checklist: 'Checklist',
}

const CHIP_KINDS: readonly OutputKind[] = ['html', 'email', 'markdown', 'table', 'keyValue', 'checklist', 'json', 'file']

const emailText = (value: Extract<RenderableOutput, { kind: 'email' }>['value']): string => {
  const header = [value.subject ? `Subject: ${value.subject}` : null, value.recipients.length ? `To: ${value.recipients.join(', ')}` : null].filter(
    (line): line is string => line !== null,
  )
  const body = value.textContent ?? value.htmlContent ?? ''
  return header.length ? `${header.join('\n')}\n\n${body}` : body
}

export const copyTextFor = (output: RenderableOutput): string | null => {
  switch (output.kind) {
    case 'text':
    case 'html':
    case 'markdown':
      return output.value
    case 'json':
      return JSON.stringify(output.value, null, 2)
    case 'table':
      return [output.value.columns, ...output.value.rows].map((row) => row.join('\t')).join('\n')
    case 'keyValue':
      return output.value.map((item) => `${item.label}: ${item.value}`).join('\n')
    case 'checklist':
      return output.value.map((item) => (item.checked === null ? `- ${item.text}` : `[${item.checked ? 'x' : ' '}] ${item.text}`)).join('\n')
    case 'email': {
      const text = emailText(output.value)
      return text.length > 0 ? text : null
    }
    default:
      return null
  }
}

export const outputKindChip = (output: RenderableOutput): string | null => {
  if (output.kind === 'file-list') {
    const count = output.value.length
    return `${count} file${count === 1 ? '' : 's'}`
  }
  return CHIP_KINDS.includes(output.kind) ? OUTPUT_KIND_LABELS[output.kind] : null
}
